/// <reference path="../types.d.ts" />
import history from '../history';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods } from '@codametrix/ui-common';
import { api } from '../core/net';
import { isServiceOrganization } from './_action-utilities';
import { STUB_ORG_RELATIONSHIP } from '../views/organizations/stub-organization';
import { inProgress } from './common';
import { syncActions } from './organization';
import { AssigningAuthorities } from '../actions/action-types';
function displayHospitals(activeOrganization) {
    var hospitalList = [];
    let orgStack = [
        activeOrganization
    ];
    while(orgStack.length > 0){
        let currOrg = orgStack.pop();
        if (currOrg === undefined) {
            break;
        }
        if (currOrg.organizationType === 'HOSPITAL') {
            hospitalList.push({
                hospitalName: currOrg.organizationName,
                hospitalId: currOrg.id
            });
        }
        currOrg.children.forEach((child)=>{
            orgStack.push(child);
        });
    }
    return hospitalList;
}
const getHospitals = createAsyncThunk(AssigningAuthorities.GET_HOSPITALS, async (id, { dispatch })=>{
    dispatch(inProgress());
    const endpoint = isNaN(id) ? `/organization/tenant/v1?tenantId=${id}` : `/organization/id/v1?organizationId=${id}`;
    const orgOpts = {
        endpoint: endpoint
    };
    const organization = await api(orgOpts);
    dispatch(syncActions.organizationSelected(organization));
    if (!isServiceOrganization(organization.organizationType)) {
        dispatch(syncActions.establishRelationship(STUB_ORG_RELATIONSHIP));
    } else {
        const params = new URLSearchParams({
            toOrganizationId: `${organization.id}`,
            fromOrganizationId: `${organization.parentId}`
        });
        const relationship = await api({
            endpoint: `/organization/relationship/v1?${params.toString()}`
        });
        dispatch(syncActions.establishRelationship(relationship));
    }
    dispatch(syncActions.organizationChildren(organization.children));
    return displayHospitals(organization);
});
const loadForm = createAsyncThunk(AssigningAuthorities.LOAD_FORM, async (id, { dispatch })=>{
    const identifier = id || `new`;
    history.push(`/cmx/config/assigning-authority/${identifier}/`);
    const assigningAuthorityGroup = await api({
        endpoint: `/primaryAssigningAuthority/v1?organizationId=` + id,
        init: {
            method: HttpMethods.GET
        }
    });
    return {
        id,
        group: assigningAuthorityGroup
    };
});
const addAuthority = createAsyncThunk(AssigningAuthorities.ADD, async (item, { dispatch })=>{
    await api({
        endpoint: `/primaryAssigningAuthority/v1`,
        init: {
            method: HttpMethods.POST
        },
        body: item
    });
    dispatch(loadForm(item.organizationId));
});
const editAuthority = createAsyncThunk(AssigningAuthorities.EDIT, async (item, { dispatch })=>{
    await api({
        endpoint: '/primaryAssigningAuthority/' + item.id + '/v1',
        init: {
            method: HttpMethods.PUT
        },
        body: item
    });
    dispatch(loadForm(item.organizationId));
});
export { getHospitals, loadForm, addAuthority, editAuthority };
